import React from "react";
import "./PrivacyPolicy.css";
import NavbarSection from "../../NavBar/Navbar.js";
import FooterSection from "../../NewFooter/Footer.js";

function PrivacyPolicy() {
  document.title = "3VO | Privacy Policy";

  return (
    <div className="bg-pages">
      <NavbarSection />
      <div className="embed rapper-style">
        <div className="embed-container">
          <div className="embed-title">Privacy Policy</div>
          {/* <div className="embed-date"></div> */}
          <div className="embed-privacy">
            <p>
              This privacy policy applies to the 3VO app (hereby referred to as
              "Application") for mobile devices that was created by 3VO Labs Ltd
              (hereby referred to as "Service Provider") as a Free service. This
              service is intended for use "AS IS".
            </p>
            <h1 className="embed-privacy-inner-titles">
              Information Collection and Use
            </h1>
            <p>
              The Application collects information when you download and use it.
              This information may include information such as <br />
              <br />
              • Your device's Internet Protocol address (e.g. IP address) <br />
              • The pages of the Application that you visit ,The time spent on
              those pages time spent on those pages <br />
              • The time spent on the Application <br />
              • The operating system you use on your mobile device <br /> <br />
              The Application does not gather precise information about the
              location of your mobile device.
              <br />
              <br /> The Service Provider may use the information you provided
              to contact you from time to time to provide you with important
              information, required notices and marketing promotions.
              <br /> <br />
              For a better experience, while using the Application, the Service
              Provider may require you to provide us with certain personally
              identifiable information, including but not limited to email,
              phone number, name, surname, username. The information that the
              Service Provider request will be retained by them and used as
              described in this privacy policy.
            </p>
            <h1 className="embed-privacy-inner-titles">Third Party Access</h1>
            <p>
              Only aggregated, anonymized data is periodically transmitted to
              external services to aid the Service Provider in improving the
              Application and their service. The Service Provider may share your
              information with third parties in the ways that are described in
              this privacy statement.
              <br /> <br />
              The Service Provider may disclose User Provided and Automatically
              Collected Information:
              <br /> <br />
              • as required by law, such as to comply with a subpoena, or
              similar legal process; <br /> • when they believe in good faith
              that disclosure is necessary to protect their rights, protect your
              safety or the safety of others, investigate fraud, or respond to a
              government request; <br />• with their trusted services providers
              who work on their behalf, do not have an independent use of the
              information we disclose to them, and have agreed to adhere to the
              rules set forth in this privacy statement.
            </p>
            <h1 className="embed-privacy-inner-titles">Opt-Out Rights</h1>
            <p>
              You can stop all collection of information by the Application
              easily by uninstalling it. You may use the standard uninstall
              processes as may be available as part of your mobile device or via
              the mobile application marketplace or network.
            </p>
            <h1 className="embed-privacy-inner-titles">
              Data Retention Policy
            </h1>
            <p>
              The Service Provider will retain User Provided data for as long as
              you use the Application and for a reasonable time thereafter. If
              you'd like them to delete User Provided Data that you have
              provided via the Application function “Delete Account” and we
              delete all info related with certain user.
            </p>
            <h1 className="embed-privacy-inner-titles">Children</h1>
            <p>
              We are especially sensitive about children’s information. Our
              Services are not targeted towards children, and our users must be
              at least eighteen (18) years old to use our services. We do not
              knowingly solicit data from or market to any persons under 18
              years of age. By using the Services, you represent that you are at
              least 18 years old. If we become aware that we have collected
              Personal Data from someone under 18, we will deactivate the
              account in question and take reasonable measures to promptly
              delete all such data from our records unless we are legally
              required to keep it. If you become aware that any Personal Data we
              may have collected is from a user under the age of 18, please
              contact us using the contact information.
            </p>
            <h1 className="embed-privacy-inner-titles">Security</h1>
            <p>
              <strong>
                The Service Provider is concerned about safeguarding the
                confidentiality of your information. The Service Provider
                provides physical, electronic, and procedural safeguards to
                protect information the Service Provider processes and
                maintains.
              </strong>
              <br />
            </p>
            <h1 className="embed-privacy-inner-titles">Changes</h1>
            <p>
              This Privacy Policy may be updated from time to time for any
              reason. The Service Provider will notify you of any changes to the
              Privacy Policy by updating this page with the new Privacy Policy.
              You are advised to consult this Privacy Policy regularly for any
              changes, as continued use is deemed approval of all changes.
              <br />
              <br />
              This privacy policy is effective as of 2025-10-20
            </p>
            <h1 className="embed-privacy-inner-titles">Your Consent</h1>
            <p>
              By using the Application, you are consenting to the processing of
              your information as set forth in this Privacy Policy now and as
              amended by us.
              <br />
            </p>

            <h1 className="embed-privacy-inner-titles">CONTACT US</h1>
            <p>
              If you have any questions regarding privacy while using the
              Application, or have questions about the practices, please contact
              the Service Provider via email at info@3vo.com.
              <br />
            </p>
          </div>
        </div>
      </div>
      <FooterSection />
    </div>
  );
}

export default PrivacyPolicy;
